import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedMaterialModule } from '../../../shared/shared-material.module';
import { InProgressModule } from '../../../shared/components/in-progress.module';
import { ScreeningResultsTableComponent } from './screening-results-table.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CustomColumnDirective, GridComponent } from '@zing/grid';

@NgModule({
  imports: [
  CommonModule,
  FormsModule,
  SharedMaterialModule,
  InProgressModule,
  RouterModule,
  GridComponent,
  CustomColumnDirective
  ],
  declarations: [
  ScreeningResultsTableComponent
  ],
  exports: [
  ScreeningResultsTableComponent,
  GridComponent,
  CustomColumnDirective
  ]
  })

export class ScreeningResultsTableModule {}
